import { HttpTokenInterceptor } from './http.token.interceptor';
import { ErrorInterceptor } from './http.error.interceptor';

export const interceptors: any[] = [HttpTokenInterceptor, ErrorInterceptor];

export * from './http.token.interceptor';
export * from './http.error.interceptor';
